import * as React from 'react';

import {
    Container,
    Row,
    Col
} from 'reactstrap';

import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';

import { FSModels } from '@finagraph/financial-statement-editor';

import { PortalTextFinancialStatements } from '../../../Models/Api/strongbox.financialportal';

type Props = {
    onUpdate: (newValue: FSModels.FinancialStatementType) => void;
    statementType: FSModels.FinancialStatementType;
    financialStatementsText?: PortalTextFinancialStatements;
}

export const FinancialStatementType: React.FC<Props> = (props): React.ReactElement => {
    const {
        onUpdate,
        statementType,
        financialStatementsText,
    } = props;

    const labelId = 'financial-statement-type-select-label';

    return (
        <Container fluid>
            <Row>
                <Col>
                    <div className={'right-aligned-col'}>
                        <FormControl fullWidth>
                            <InputLabel id={labelId}>{financialStatementsText?.statementType || ''}</InputLabel>
                            <Select
                                labelId={labelId}
                                label={financialStatementsText?.statementType || ''}
                                value={statementType}
                                // @ts-ignore TS2345   this will have a correct value
                                onChange={e => onUpdate(e.target.value)}
                                MenuProps={{
                                    sx: {
                                        '& div': {
                                            borderRadius: 0
                                        }
                                    }
                                }}
                                sx={{ borderRadius: '0px' }}
                            >
                                <MenuItem value={FSModels.FinancialStatementType.BalanceSheet}>{financialStatementsText?.fsTypeBalanceSheet || ''}</MenuItem>
                                <MenuItem value={FSModels.FinancialStatementType.IncomeStatement}>{financialStatementsText?.fsTypeIncomeStatement || ''}</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
